import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../Components/RootLayout/RootLayout";

import { ErrorPage } from "./ErrorPage";
import Home from "../Page/Home";
import Login from "../Page/Login";
import Registration from "../Page/Registration";
import Contact from "../Page/Contact";
import ProductDetails from "../Page/ProductDetail";
import Cart from "../Page/Cart";
// import Dashboard from "../Dashboard";
import Products from "../Page/Products";
// import Users from "../Dashboard/Users";
// import Categories from "../Dashboard/Categories";
// import ProductsControl from "../Dashboard/ProductsControl";
import CategoriesSections from "../Sections/CategoriesSections";
import FavoriteList from "../Page/Favorite";
// import OrdersControl from "../Dashboard/Orders";
// import Slider from "../Dashboard/Slider";
import ProfileUser from "../Page/ProfileUser";
import MyOrder from "../Page/MyOrder";
import ProductsCategorie from "../Page/ProductsCategorie";
import ProductsBrand from "../Page/ProductsBrand";
import Brands from "../Page/Brands";
import FeaturedProducts from "../Page/FeaturedProducts";
// import { authLoader } from "../utils/authLoader";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    // loader: authLoader,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      { path: "Products/:id", element: <ProductDetails /> },
      { path: "Cart", element: <Cart /> },
      { path: "Contact", element: <Contact /> },
      { path: "AboutUs", element: <ErrorPage /> },
      { path: "ProfileUser", element: <ProfileUser /> },
      { path: "MyOrder", element: <MyOrder /> },
      { path: "Favorite", element: <FavoriteList /> },
      { path: "Products", element: <Products /> },
      { path: "FeaturedProducts", element: <FeaturedProducts /> },
      { path: "Brands", element: <Brands /> },
      { path: "CategoriesSections", element: <CategoriesSections /> },
      { path: "ProductsCategorie/:id", element: <ProductsCategorie /> },
      { path: "ProductsBrand/:id", element: <ProductsBrand /> },
    ],
  },
  { path: "Login", element: <Login /> },
  { path: "signUp", element: <Registration /> },
]);
